import React from 'react';
import styled from 'styled-components';
import BooksGrid from '../BookComponents/BooksGrid';

const Wrapper = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.h1`
  margin-bottom: 2rem;
`;

function Home({ user }) {
  return (
    <Wrapper>
      <Header>Najnovije knjige</Header>
      <BooksGrid user={user} />
    </Wrapper>
  );
}

export default Home;
